import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ApiWrapper, PagingResults } from '../../types/utils';
import {
    ContentReportList,
    ContentReportStatus,
    CreateReportParams,
    GetReportsParams,
    UpdateReportStatusParams,
} from '../../types';

export class JContentReportApi extends JBaseApi {
    public getReports(
        params: GetReportsParams = {},
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<PagingResults<ContentReportList>>> {
        return this.network.post({
            o: 'contentReport',
            f: 'list',
            ...params,
            signal: options?.signal,
        } as OF);
    }

    public createReport(
        params: CreateReportParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<string>> {
        return this.network.postCSRF({
            o: 'contentReport',
            f: 'createReport',
            ...params,
            signal: options?.signal,
        } as OF);
    }

    public updateStatus(
        params: UpdateReportStatusParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<ContentReportStatus>> {
        return this.network.postCSRF({
            o: 'contentReport',
            f: 'changeStatus',
            ...params,
            signal: options?.signal,
        } as OF);
    }
}
